function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useCallback, useState } from 'react';
import { NotificationsContext } from "../notificationsContext/NotificationsContext";
import { NotificationsList } from "./notificationsList/NotificationsList";
export var NotificationsContextProvider = function NotificationsContextProvider(props) {
  var children = props.children,
      notificationsRenderer = props.notificationsRenderer,
      rest = _objectWithoutProperties(props, ["children", "notificationsRenderer"]);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      notifications = _useState2[0],
      setNotifications = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      last = _useState4[0],
      setLast = _useState4[1];

  var makeRemoveNotification = function makeRemoveNotification(notification) {
    return function () {
      setNotifications(function (oldNotifications) {
        return oldNotifications.filter(function (oldNotification) {
          return oldNotification !== notification;
        });
      });
    };
  };

  var addNotification = useCallback(function (notification) {
    var notificationWithKey = _objectSpread({}, notification, {
      key: last
    });

    setLast(last + 1);
    setNotifications([].concat(_toConsumableArray(notifications), [notificationWithKey]));

    if (notificationWithKey.time !== 0) {
      // start hiding
      setTimeout(function () {
        setNotifications(function (oldNotifications) {
          var newNotifications = oldNotifications.map(function (oldNotification) {
            if (oldNotification === notificationWithKey) {
              oldNotification.fading = true;
            }

            return oldNotification;
          });
          return newNotifications;
        });
      }, notificationWithKey.time || 3000);
      setTimeout(function () {
        setNotifications(function (innerOldNotifications) {
          return innerOldNotifications.filter(function (oldNotification) {
            return oldNotification !== notificationWithKey;
          });
        });
      }, (notificationWithKey.time || 3000) + 1000);
    }
  }, [notifications]);
  var renderer = notificationsRenderer ? notificationsRenderer : NotificationsList;
  return React.createElement(NotificationsContext.Provider, {
    value: _objectSpread({}, rest, {
      showNotification: addNotification
    })
  }, children, renderer(notifications, makeRemoveNotification));
};